import React from 'react';
import { DashboardLayout } from '../components/layout';
import BroadcastComposer from '../components/broadcast/BroadcastComposer';

export default function AdminBroadcastPage() {
  return (
    <DashboardLayout title="Broadcast">
      <BroadcastComposer role="admin" />
    </DashboardLayout>
  );
}
